<button class="ai-fab" (click)="clicked.emit()" aria-label="Open AI Assistant">
  <span class="ai-fab__pulse"></span>
  <svg class="ai-fab__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 2L14.2 8.8L21 10L14.2 11.2L12 18L9.8 11.2L3 10L9.8 8.8L12 2Z" fill="white" />
    <path d="M20 2L21 5L24 6L21 7L20 10L19 7L16 6L19 5L20 2Z" fill="white" opacity="0.7" />
    <circle cx="5" cy="18" r="1.3" fill="white" opacity="0.5" />
  </svg>
  <span class="ai-fab__label">Ask AI</span>
</button>